<template>
  <div :class="$style.modal">
    <div :class="$style.modalContent">
      <ModalHeader
        :handleClose="handleCancelX"
        :headerText="headerText"
        :showClose="showClose"
      />
      <div
        :class="$style.modalBody"
        data-test-id="modalBody"
      >
        <slot name="message" />
        <MarkdownBlock
          v-if="mdTemplate"
          :mdTemplate="mdTemplate"
        />
        <p
          v-else-if="bodyText"
        >
          {{ bodyText }}
        </p>
        <slot />
      </div>
      <LoadingOverlay
        :showLoadingOverlay="showLoadingOverlay"
      />
      <ModalFooter
        :cancelText="cancelText"
        :enableMainAction="enableMainAction"
        :handleClose="handleCancel"
        :handleMainAction="handleContinue"
        :kbLink="kbLink"
        :kbLinkText="kbLinkText"
        :loading="loading"
        :mainActionAttention="mainActionAttention"
        :mainActionText="continueText"
      />
    </div>
  </div>
</template>
<script>
import { MarkdownBlock } from '@jumpcloud/ui-components';
import LoadingOverlay from 'client/components/LoadingOverlay/LoadingOverlay.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import ModalFooter from 'client/components/Modal/ModalComponents/ModalFooter.vue';
import ModalHeader from 'client/components/Modal/ModalComponents/ModalHeader.vue';

export default {
  name: 'ConfirmationModal',

  inject: ['$validator'],

  components: {
    LoadingOverlay,
    MarkdownBlock,
    ModalFooter,
    ModalHeader,
  },

  props: {
    bodyText: {
      default: '',
      type: String,
    },
    cancelText: {
      default: 'cancel',
      type: String,
    },
    continueText: {
      default: 'continue',
      type: String,
    },
    enableMainAction: {
      default: true,
      type: Boolean,
    },
    handleCancel: {
      default: () => ModalEventBus.close(),
      type: Function,
    },
    handleCancelX: {
      default: () => ModalEventBus.close(),
      type: Function,
    },
    handleContinue: {
      default: () => ModalEventBus.close(),
      type: Function,
    },
    headerText: {
      default: 'An Empty Confirmation Modal',
      type: String,
    },
    kbLink: {
      default: undefined,
      type: String,
    },
    kbLinkText: {
      default: undefined,
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    mainActionAttention: {
      default: false,
      type: Boolean,
    },
    mdTemplate: {
      default: '',
      type: String,
    },
    showClose: {
      default: true,
      type: Boolean,
    },
    showLoadingOverlay: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
<style module>
@import '../css/ModalStyles.css';
</style>
